export const DEFAULT_COLLECTION_LABEL = "Untitled collection";
